/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React, { useContext } from 'react';

type BoxPickerContextType = {
  isActive: (value: any) => boolean;
  onItemChange: (value: any) => void;
};

const defaultContextValue: BoxPickerContextType = {
  isActive: () => false,
  onItemChange: () => {},
};

export const BoxPickerContext = React.createContext(defaultContextValue);

export const useComponentContext = () => useContext(BoxPickerContext);
